// withPermission.tsx
import React from 'react';
import { usePermission } from './../../services/usePermission';
 
type PermissionProps = {
  moduleCode: string;
  pageCode:string;
  privilege: string;
  children: React.ReactNode;
};
 
export const WithPermission: React.FC<PermissionProps> = ({ moduleCode,pageCode, privilege, children }) => {
  const hasPermission = usePermission(moduleCode,pageCode, privilege);
  // Render the children if the user has the required permission, else render nothing
  return <>{hasPermission ? children : null}</>;
};